import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=0fa15c46"
import script from "./Unavailable.vue?vue&type=script&lang=js"
export * from "./Unavailable.vue?vue&type=script&lang=js"
import style0 from "./Unavailable.vue?vue&type=style&index=0&id=0fa15c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports